import { cn } from "app/lib/utils"

type Props = {
  src: string
  size?: number
  className?: string
}

export default function PlayerIcon({ src, size = 24, className }: Props) {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center overflow-hidden",
        className
      )}
      style={{ width: size, height: size }}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src={src} alt="" className="size-full object-contain" />
    </span>
  )
}
